export { default } from './GlobalLoading';
